import { useState } from 'react';
import { faqList } from '@/mocks/home';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-label font-semibold text-primary-500 mb-2 tracking-wider uppercase">
            FAQ
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            자주 하는 <span className="text-primary-500">질문</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label">
            궁금하신 점을 빠르게 확인해 보세요.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqList.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl md:rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                className="w-full flex items-center gap-3 md:gap-4 p-5 md:p-6 text-left"
              >
                <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-label font-bold text-sm">Q</span>
                </span>
                <strong className="flex-1 text-sm md:text-base font-label font-semibold text-foreground-900">
                  {faq.question}
                </strong>
                <i
                  className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform duration-300 ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-48' : 'max-h-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6 pl-16 md:pl-20">
                  <p className="text-sm text-foreground-600 font-label leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}